import { render, staticRenderFns } from "./DotsHorizontal.vue?vue&type=template&id=a8ba8946"
import script from "./DotsHorizontal.vue?vue&type=script&lang=js"
export * from "./DotsHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports